import React from 'react'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import CloseIcon from '@material-ui/icons/Close'
import { withStyles } from '@material-ui/core/styles'

import LaunchDateChangeModal from './LaunchDateChangeModal'

const styles = {
  dialog: {
    '& .MuiDialogContent-root, .MuiDialogTitle-root, .MuiDialogActions-root': {
      padding: 0,
    },
    '& .MuiDialog-paper': {
      margin: 8,
      maxWidth: '900px',
      width: 'calc(100vw - 16px)',
      '@media screen and (min-width: 640px)': {
        width: 'auto',
        margin: 16,
      },
      '@media screen and (max-width: 480px)': {
        margin: 4,
        width: 'calc(100vw - 8px)',
      },
    },
  },
  closeBar: {
    display: 'flex',
    justifyContent: 'flex-end',
    paddingRight: 20,
    paddingTop: 20,
    '@media screen and (max-width: 480px)': {
      paddingRight: 12,
      paddingTop: 12,
    },
  },
  contentWrap: {
    padding: '0 40px 40px',
    width: '100%',
    '@media screen and (max-width: 640px)': {
      padding: '0 24px 40px',
    },
    '@media screen and (max-width: 480px)': {
      padding: '0 16px 24px',
    },
  },
  title: {
    textAlign: 'center',
    marginBottom: 32,
    '& h2': {
      fontWeight: 500,
      fontSize: 28,
      lineHeight: 1.5,
      fontFamily: "'Roboto', sans-serif",
      margin: 0,
      color: '#000000',
      alignSelf: 'center',
      '@media screen and (max-width: 480px)': {
        fontSize: 24,
        lineHeight: 1.4,
      },
    },
  },
  textWrap: {
    fontWeight: 400,
    fontSize: 16,
    color: '#505050',
    textAlign: 'left',
    fontFamily: "'Roboto', sans-serif",
    lineHeight: 1.5,
    marginBottom: 32,
    '& p': {
      margin: 0,
    },
    '@media screen and (max-width: 480px)': {
      fontSize: 14,
      marginBottom: 24,
    },
  },
  buttonRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    '@media screen and (max-width: 480px)': {
      flexDirection: 'column',
      gap: 16,
      alignItems: 'stretch',
    },
  },
  rightColumn: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    gap: 4,
    '@media screen and (max-width: 480px)': {
      alignItems: 'center',
      width: '100%',
    },
  },
  cancelButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 4,
    border: '1px solid #004360',
    color: '#004360',
    backgroundColor: '#FFFFFF',
    padding: '9px 16px',
    height: 36,
    fontWeight: 500,
    fontFamily: "'Roboto', sans-serif",
    fontSize: 14,
    lineHeight: '18px',
    textTransform: 'uppercase',
    letterSpacing: '0.16px',
    cursor: 'pointer',
    boxShadow: '0px 2px 4px -1px rgba(0,0,0,0.2)',
    transition: 'all .2s',
    '&:hover': {
      backgroundColor: '#004360',
      color: '#FFFFFF',
    },
    '@media screen and (max-width: 480px)': {
      width: '100%',
      order: 2,
    },
  },
  actionButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 4,
    border: 'none',
    color: '#FFFFFF',
    backgroundColor: '#004360',
    padding: '9px 16px',
    height: 36,
    fontWeight: 500,
    fontFamily: "'Roboto', sans-serif",
    fontSize: 14,
    lineHeight: '18px',
    textTransform: 'uppercase',
    letterSpacing: '0.16px',
    cursor: 'pointer',
    boxShadow:
      '0px 2px 4px 0px rgba(0,0,0,0.14), 0px 3px 4px 0px rgba(0,0,0,0.12), 0px 1px 5px 0px rgba(0,0,0,0.2)',
    transition: 'all .2s',
    '&:hover': {
      backgroundColor: '#d73650',
    },
    '@media screen and (max-width: 480px)': {
      width: '100%',
    },
  },
  footerHint: {
    fontWeight: 400,
    fontSize: 14,
    lineHeight: 1.5,
    color: '#505050',
    textAlign: 'right',
    fontFamily: "'Roboto', sans-serif",
    whiteSpace: 'nowrap',
    '@media screen and (max-width: 480px)': {
      textAlign: 'center',
      whiteSpace: 'normal',
      fontSize: 12,
    },
  },
}

const LaunchDateChangeDialog = ({ classes, open, onClose, onConfirm }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="launch-date-change-dialog"
      className={classes.dialog}
      disableEnforceFocus={true}
    >
      <Box className={classes.closeBar}>
        <Button color="inherit" size="small" onClick={onClose}>
          <CloseIcon fontSize="default" />
        </Button>
      </Box>
      <Box className={classes.contentWrap}>
        <DialogContent>
          <DialogTitle id="launch-date-change-dialog" className={classes.title}>
            Changing the launch date may require a new asset generation
          </DialogTitle>
          <div className={classes.textWrap}>
            <LaunchDateChangeModal />
          </div>
          <div className={classes.buttonRow}>
            <button className={classes.cancelButton} onClick={onClose}>
              CLOSE
            </button>
            <div className={classes.rightColumn}>
              <button className={classes.actionButton} onClick={onConfirm}>
                SAVE CHANGES
              </button>
              <div className={classes.footerHint}>
                You will need to download the new assets on internal files page
                after they are generated
              </div>
            </div>
          </div>
        </DialogContent>
      </Box>
    </Dialog>
  )
}

export default withStyles(styles)(LaunchDateChangeDialog)
